import { defineMessages } from 'react-intl';

const messages = defineMessages({
  size: { id: 'Size', defaultMessage: 'Dimensione' },
  title: { id: 'Title', defaultMessage: 'Titolo' },
  description: { id: 'Description', defaultMessage: 'Etichetta' },
  logo: { id: 'Logo', defaultMessage: 'Logo' },
  logo_description: {
    id: 'MultimediaBlock_Logo',
    defaultMessage: "Aggiungi un logo o un'icona di fianco al titolo.",
  },
  image: { id: 'Image', defaultMessage: 'Immagine' },
  image_description: {
    id: 'MultimediaBlock_Image description',
    defaultMessage:
      "Se viene selezionato un video, questa sarà l'immagine di copertina che verrà mostrata finché il video non sarà stato caricato. Se non viene selezionato nessun video, questa sarà l'immagine di sfondo della slide.",
  },
  buttonText: {
    id: 'MultimediaBlock_Testo sul bottone',
    defaultMessage: 'Testo sul bottone',
  },
  buttonTextDescription: {
    id: 'MultimediaBlock_Testo sul bottone description',
    defaultMessage:
      "Se presente, verrà mostrato un bottone che al click porterà alla destinazione scelta nel campo 'Destinazione'. Se non compilato, il link verrà posizionato sul titolo della slide",
  },
  primary: { id: 'primary', defaultMessage: 'Primario' },
  secondary: { id: 'secondary', defaultMessage: 'Secondario' },
  tertiary: { id: 'tertiary', defaultMessage: 'Terziario' },
  white: { id: 'white', defaultMessage: 'Bianco' },
  cta_color: {
    id: 'MultimediaBlock_Color del bottone',
    defaultMessage: 'Colore del bottone',
  },
  autoplay: { id: 'Autoplay', defaultMessage: 'Autoplay' },
  fullwidth: { id: 'Fullwidth', defaultMessage: 'A tutta larghezza' },
  bold_title: {
    id: 'bold_title',
    defaultMessage: 'Titolo grassetto',
  },
  title_as_h1: {
    id: 'title_as_h1',
    defaultMessage: 'Imposta il titolo della slide come titolo della pagina',
  },
  title_as_h1_description: {
    id: 'title_as_h1_description',
    defaultMessage:
      'Selezionando questa opzione, il titolo della slide verrà impostato come tag html <h1>. N.B. Occorre che ogni pagina abbia solo un tag <h1>',
  },
});

const schema = (intl) => ({
  title: 'Blocco Multimedia',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['autoplay', 'fullwidth', 'size', 'slides'],
    },
  ],
  properties: {
    autoplay: {
      title: intl.formatMessage(messages.autoplay),
      type: 'boolean',
      default: false,
    },
    fullwidth: {
      title: intl.formatMessage(messages.fullwidth),
      type: 'boolean',
      default: false,
    },
    size: {
      title: intl.formatMessage(messages.size),
      type: 'size',
      default: 'l',
    },
    slides: {
      title: 'Slides',
      widget: 'object_list',
      schema: {
        title: 'Slide',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'title',
              'bold_title',
              'title_as_h1',
              'description',
              'logo_icon',
              'image',
              'video',
              'href',
              'href_title',
              'cta_color',
            ],
          },
        ],
        properties: {
          title: {
            title: intl.formatMessage(messages.title),
          },
          bold_title: {
            title: intl.formatMessage(messages.bold_title),
            type: 'boolean',
          },
          title_as_h1: {
            title: intl.formatMessage(messages.title_as_h1),
            type: 'boolean',
            description: intl.formatMessage(messages.title_as_h1_description),
          },
          description: {
            title: intl.formatMessage(messages.description),
          },
          logo_icon: {
            title: intl.formatMessage(messages.logo),
            description: intl.formatMessage(messages.logo_description),
            widget: 'object_browser',
            mode: 'image',
            allowExternals: false,
          },
          image: {
            title: intl.formatMessage(messages.image),
            description: intl.formatMessage(messages.image_description),
            widget: 'object_browser',
            mode: 'image',
            allowExternals: false,
          },
          video: {
            title: 'Video',
            widget: 'object_browser',
            widgetOptions: {
              pattern_options: {
                selectableTypes: ['File'],
                maximumSelectionSize: 1,
              },
            },
            allowExternals: false,
          },
          href: {
            title: 'Link',
            widget: 'object_browser',
            mode: 'link',
            allowExternals: true,
          },
          href_title: {
            title: intl.formatMessage(messages.buttonText),
            description: intl.formatMessage(messages.buttonTextDescription),
          },
          cta_color: {
            title: intl.formatMessage(messages.cta_color),
            widget: 'color_list',
            colors: [
              {
                name: 'primary',
                label: intl.formatMessage(messages.primary),
              },
              {
                name: 'secondary',
                label: intl.formatMessage(messages.secondary),
              },
              {
                name: 'tertiary',
                label: intl.formatMessage(messages.tertiary),
              },
              { name: 'white', label: intl.formatMessage(messages.white) },
            ],
            defaultValue: 'white',
          },
        },
        required: [],
      },
    },
  },
  required: [],
});

export default schema;
